import { HorizontalBarChartComponent } from '../charts/horizontal-bar-chart-component'

export class AFTopHashtags extends HorizontalBarChartComponent {
 static config = {
  selector: 'afTopHashtags',
  controller: AFTopHashtags,
  bindings: HorizontalBarChartComponent.config.bindings,
  template: HorizontalBarChartComponent.config.template,
 }

 setProperties() {
  this.prefix = '#'
  this.colorPalette = ['#F84D80']
  this.onPointClick = this.keywordPointClick
  this.sortDescending = true
 }
}
